import { DateFormat, FORMATS } from '@app/pipes/localized-date/types';
import { Locale } from '@app/types/translatable.type';
import { format } from 'date-fns';
import frLocale from 'date-fns/locale/fr';

export const formatDate = (date: Date, formatType: DateFormat, locale: string): string => {
    const dateFnsLocale = (locale as Locale) === 'fr_CA' ? frLocale : undefined;
    return format(date, FORMATS[formatType][locale as Locale], { locale: dateFnsLocale });
};
